import React from "react";

import { getWoosmapKey } from "@utils/configuration/aem";
import { ScriptLoadingStates, useScript } from "@utils/hooks/useScript.hook";

type WoosmapInitializerProps = {
    children: React.ReactNode;
    FallbackComponent?: React.FC;
};

const useWoosmapScript = () => {
    const woosmapKey = getWoosmapKey();

    const scriptStatus = useScript(
        `https://sdk.woosmap.com/map/map.js?key=${woosmapKey}`,
        "woosmap",
    );

    return scriptStatus;
};

const WoosmapInitializer = ({
    FallbackComponent,
    children,
}: WoosmapInitializerProps) => {
    const status = useWoosmapScript();

    if (status === ScriptLoadingStates.Ready) {
        return <>{children}</>;
    }

    return FallbackComponent ? <FallbackComponent /> : null;
};

type withWoosmapProps = {};

const withWoosMap = <T extends withWoosmapProps>(
    WrappedComponent: React.ComponentType<T>,
    FallbackComponent?: React.FC,
) => {
    const ComponentWithWoosMap = (props: T) => {
        return (
            <WoosmapInitializer FallbackComponent={FallbackComponent}>
                <WrappedComponent {...props} />
            </WoosmapInitializer>
        );
    };
    return ComponentWithWoosMap;
};

export { withWoosMap };
